
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/terms",
      function () {
        return require("private-next-pages/about/terms/index.page_en_US.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/terms"])
      });
    }
  